var _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrowShrinkDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 5,
  cy: 5,
  fill: "#d1f2cf",
  rx: 5
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "rx",
  calcMode: "spline",
  dur: "5s",
  keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1",
  keyTimes: "0; 0.08; 0.2; 0.28; 0.36; 0.42; 0.58; 0.66; 0.74; 0.86; 0.92; 1",
  repeatCount: "indefinite",
  values: "0; 0; 3; 3; 5; 3; 3; 5; 3; 3; 0; 0"
}))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 5,
  cy: 5,
  fill: "#4fba50",
  rx: 4
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "rx",
  calcMode: "spline",
  dur: "5s",
  keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1",
  keyTimes: "0; 0.08; 0.2; 0.28; 0.36; 0.42; 0.58; 0.66; 0.74; 0.86; 0.92; 1",
  repeatCount: "indefinite",
  values: "0; 0; 1.5; 1.5; 4; 1.5; 1.5; 4; 1.5; 1.5; 0; 0"
}))));
export default SvgGrowShrinkDot;